import { useQuery, useMutation } from '@apollo/client';
import {
  Sheet,
  BackgroundIcon,
  AppContext,
  isAuthorised,
  SkeletonLoading,
  EventEmitter,
  useStateCallback,
  toast,
  withErrorBoundary,
  useIsAuthorisedHook,
  useCurrentServicePortal
} from '@nile/components';
import ErrorPage from '@nile/components/src/Components/ErrorPage';
import { useFlags } from 'launchdarkly-react-client-sdk';
import {
  NavigationContainer,
  TicketToolbar,
  TaskToolbar,
  MailToolbar
} from '@nile/mangifera/src/Containers/ToolbarContainers';
import { ProjectToolbar } from '@nile/projects/src/Containers';
import { Button } from '@superops/ui-design-system';
import {
  GET_TASKVIEWS,
  GET_TICKETVIEWS
} from '@nile/mangifera/src/Graphql/Mutations/ticketview';
import {
  GET_ENTITY_PROPERTIES,
  useCachedQuery,
  CREATE_TASK,
  MERGE_TICKET,
  SAVE_TICKET_CONVERSATION,
  SOFT_TICKET_DELETE,
  UPDATE_TICKETS,
  MARKSPAM_TICKETS,
  HARD_TICKET_DELETE,
  RESTORE_TICKETS,
  AccountClient,
  GET_PERSONALIZATION_BY_NAME
} from '@nile/graphql';
import envConfig from '@nile/home/src/Config/env';
import { GET_PROJECT_VIEWS } from '@nile/projects/src/Graphql';
import React, {
  Component,
  Suspense,
  useContext,
  useEffect,
  useReducer,
  useState
} from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { SubPage } from '../../Pages/Protected/Ticket/Route';
import { VIEW_ID } from '@nile/client_management/src/Constants/Client';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import { SVGIcon } from '@superops/super-icons';
import { useGlobalState } from '@nile/components/src/Managers/StateManager';
import { SizeMe } from 'react-sizeme';
import {
  MONICA_AI_VIEWS,
  WORKSPACE_MODULE_VIEWS
} from '@nile/mangifera/src/Constants/workspace';
import MonicaWorkspaceToolbar from '@nile/mangifera/src/Containers/ToolbarContainers/MonicaWorkspaceToolbar.tsx';

const currentView = VIEW_ID;
const StyleNavContainer = styled.div`
  width: 300px;
  min-width: 300px;
  max-width: 300px;
  background-color: var(--sops-solid-purple-to-black);
  border-right: 1px solid #fff;
  color: #000000;
  padding: 8px;
  overflow: auto;
  height: 100%;

  .Polaris-Navigation {
    background: #f4f5f7;
  }
`;

const StylePageContainer = styled.div`
  width: ${(props) => {
    if (props.isClassicView) {
      return props.navOpen && props.isLargeScreen
        ? 'calc(100% - 300px)'
        : 'calc(100%)';
    }
    return `calc(100vw - ${props.navOpen ? 385 : 85}px)`;
  }};
  left: ${(props) =>
    props.isClassicView
      ? props.navOpen && props.isLargeScreen
        ? '300px'
        : '0px'
      : props.navOpen
      ? '300px'
      : '0px'};

  // transition: transform 0.2s ease-out 0s;
  position: relative;
  // transform: translate3d(0, 0, 0);
  transition: ${(props) =>
    props.isClassicView ? '' : 'left 0.2s ease-out 0s,width 0.2s ease 0s'};
  padding-bottom: ${(props) => (props.isClassicView ? '0px' : '10px')};
  .tbody .tr {
    height: 52px !important;
  }
`;

const StyleContainer = styled.div`
  width: 100%;
  display: flex;
  background: var(--sops-bg-white);
  position: relative;
  height: calc(100% - 90px);
  .workspace-nav-sheet {
    z-index: 11 !important;
  }
`;

class MainNavigation extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loadedComponents: {},
      components: [],
      activePage: null,
      open: props.context.viewType !== 'classic' // default close only on classic view other views this will be in open state.
    };
  }

  getPathName(path) {
    const pathname = path || this.props.history.location.pathname;
    return pathname.split('/')[pathname.split('/').length - 1];
  }

  componentDidMount() {
    this.setState({ activePage: this.getPathName() });
  }

  componentDidUpdate(prevProps, prevState) {
    const currPath = this.getPathName();
    if (prevState.activePage !== currPath) {
      this.setState({ activePage: currPath });
    }
  }

  handleClick(item) {
    this.setState({ activePage: this.getPathName(item.url) });
  }

  getToolbar(viewType, activeView) {
    switch (viewType) {
      case 'ticket':
        return (
          <TicketToolbar
            navMenu={this.getNavToggle()}
            toggleNavMenu={this.toggleNavMenu.bind(this)}
            closeNavMenu={this.closeNavMenu.bind(this)}
            entitiesMeta={this.props.entitiesMeta}
            isClassicView={this.props.context.viewType === 'classic'}
            ticketViews={this.props.ticketViews}
          />
        );
      case 'project':
        return (
          <ProjectToolbar
            navMenu={this.getNavToggle()}
            toggleNavMenu={this.toggleNavMenu.bind(this)}
            viewType={this.props.context.projectViewType}
            setViewType={this.props.context.setProjectViewType}
          />
        );
      case 'tasks':
        return (
          <TaskToolbar
            navMenu={this.getNavToggle()}
            toggleNavMenu={this.toggleNavMenu.bind(this)}
            closeNavMenu={this.closeNavMenu.bind(this)}
            entitiesMeta={this.props.entitiesMeta}
          />
        );
      case 'mails':
        return (
          <MailToolbar
            navMenu={this.getNavToggle()}
            toggleNavMenu={this.toggleNavMenu.bind(this)}
            entitiesMeta={this.props.entitiesMeta}
          />
        );
      case 'monica-ai':
        return (
          <MonicaWorkspaceToolbar
            navMenu={this.getNavToggle()}
            toggleNavMenu={this.toggleNavMenu.bind(this)}
          />
        );
      default:
        return <TicketToolbar />;
    }
  }

  toggleNavMenu() {
    this.setState({ open: !this.state.open });
  }

  closeNavMenu() {
    if (this.state.open) {
      this.setState({ open: false });
    }
  }

  getNavToggle() {
    return <Button icon={<SVGIcon name="CustomViewsPanel" size="lg" />} />;
  }

  render() {
    const { activePage } = this.state;
    const {
      data,
      ticketViews,
      activeView,
      match,
      taskViews,
      projectViews,
      context
    } = this.props;
    const isClassicView = context.viewType === 'classic';
    return (
      <SizeMe monitorHeight monitorWidth>
        {({ size }) => {
          const { width } = size;
          const isLargeScreen = document?.documentElement?.clientWidth > 1900;

          return (
            <div className="fx col full-height">
              {this.getToolbar(match.params.viewtype, activeView)}
              <StyleContainer>
                <Sheet
                  sheet={
                    <StyleNavContainer>
                      <NavigationContainer
                        taskViews={taskViews}
                        ticketViews={ticketViews}
                        projectViews={projectViews}
                      />
                    </StyleNavContainer>
                  }
                  docked={false}
                  sheetClassName={`workspaceNavSheet ${isClassicView &&
                    'accordion-transition'}`}
                  open={this.state.open}
                  transitions
                  styles={{
                    sheet: isClassicView && {
                      boxShadow: '0px 2px 20px rgba(0, 0, 0, 0.1)'
                    }
                  }}
                />
                <StylePageContainer
                  navOpen={this.state.open}
                  isClassicView={isClassicView}
                  className="full-height"
                  currentWidth={width}
                  isLargeScreen={isLargeScreen}
                >
                  <Suspense fallback={<div>Loading a view</div>}>
                    {activePage ? (
                      <SubPage
                        name={match.params.pagename}
                        viewtype={match.params.viewtype}
                        ticketViews={ticketViews}
                        taskViews={taskViews}
                        projectViews={projectViews}
                        activeView={activeView}
                        context={context}
                      />
                    ) : (
                      <div>Loading a view</div>
                    )}
                  </Suspense>
                </StylePageContainer>
              </StyleContainer>
            </div>
          );
        }}
      </SizeMe>
    );
  }
}

function StepNavigation(props) {
  const { match } = props;
  const { user } = useContext(AppContext);
  const flags = useFlags();
  const context = useContext(TicketContext);
  const reference = user?.role?.roleFeatureList || [];
  const { loading, error, data, refetch } = useCachedQuery(GET_TICKETVIEWS, {
    // fetchPolicy: 'network-only'
  });

  const { accountType } = useContext(AppContext);

  const isTaskViewAuthorized = useIsAuthorisedHook('taskViews.view');

  const {
    loading: entitiesLoading,
    error: entitiesError,
    data: allEntities
  } = useCachedQuery(GET_ENTITY_PROPERTIES, { client: AccountClient });

  const {
    loading: taskViewLoading,
    error: taskViewError,
    data: taskViewData,
    refetch: refetchTaskViews
  } = useCachedQuery(GET_TASKVIEWS, {
    // fetchPolicy: 'network-only'
    skip: !isTaskViewAuthorized
  });

  const checkToSkipProjectAPI = () => {
    return !isAuthorised(reference, 'project.view');
  };

  const {
    loading: projectViewsLoading,
    error: projectViewsError,
    data: projectViewsData,
    refetch: refetchProjectViews
  } = useCachedQuery(GET_PROJECT_VIEWS, {
    fetchPolicy: 'cache-and-network',
    skip: checkToSkipProjectAPI()
  });
  const manageViewCategoryName = useCurrentServicePortal('workspace');

  const {
    data: workspaceSidebarPersonalization,
    loading: workspaceSidebarPersonalizationLoading,
    refetch: workspaceSidebarPersonalizationRefetch
  } = useQuery(GET_PERSONALIZATION_BY_NAME, {
    client: AccountClient,
    fetchPolicy: 'network-only',
    variables: {
      userId: user?.userId,
      category: manageViewCategoryName,
      name: 'ManageViews'
    }
  });

  function getPersonalizedTicketViews() {
    const sidebarData =
      workspaceSidebarPersonalization?.getPersonalizationByCategoryAndName;
    const ticketViews = data?.getTicketViews;

    if (sidebarData) {
      const ticketViewIdPersonalizationList = JSON.parse(sidebarData.value)
        ?.ticket?.list;
      if (ticketViewIdPersonalizationList) {
        const ticketViewLists = ticketViews
          .filter((item) => ticketViewIdPersonalizationList.includes(item.id))
          .sort(
            (a, b) =>
              ticketViewIdPersonalizationList.indexOf(a?.id) -
              ticketViewIdPersonalizationList.indexOf(b?.id)
          );
        if (ticketViewLists.length) {
          return ticketViewLists;
        }
      }
    }
    return ticketViews;
  }

  function getPersonalizedTaskViews() {
    const sidebarData =
      workspaceSidebarPersonalization?.getPersonalizationByCategoryAndName;
    const taskViews = taskViewData?.getTaskViews;

    if (!taskViews) return [];

    if (sidebarData) {
      const taskViewIdPersonalizationList = JSON.parse(sidebarData.value)?.task
        ?.list;
      if (taskViewIdPersonalizationList) {
        const viewsList = [];

        taskViewIdPersonalizationList.forEach((id) => {
          const view = taskViews.find((item) => item.id === id);
          if (view) {
            viewsList.push(view);
          }
        });
        if (viewsList.length) {
          return viewsList;
        }
      }
    }

    return taskViews;
  }

  function getPersonalizedProjectViews() {
    const sidebarData =
      workspaceSidebarPersonalization?.getPersonalizationByCategoryAndName;
    const projectViews = projectViewsData?.getProjectViews;

    if (!projectViews) return [];

    if (sidebarData) {
      const projectViewIdPersonalizationList = JSON.parse(sidebarData.value)
        ?.project?.list;
      if (projectViewIdPersonalizationList) {
        const viewsList = [];

        projectViewIdPersonalizationList.forEach((id) => {
          const view = projectViews.find((item) => item.id === id);
          if (view) {
            viewsList.push(view);
          }
        });

        return viewsList;
      }
    }

    return projectViews;
  }

  const getActiveView = (viewType) => {
    switch (viewType) {
      case WORKSPACE_MODULE_VIEWS.ticket:
        return getPersonalizedTicketViews().find((item) => {
          return item.id === match.params.id;
        });
      case WORKSPACE_MODULE_VIEWS.tasks:
        return taskViewData?.getTaskViews?.find((item) => {
          return item.id === match.params.id;
        });
      case WORKSPACE_MODULE_VIEWS.project:
        return projectViewsData?.getProjectViews?.find(
          (item) => item.id === match.params.id
        );
      case WORKSPACE_MODULE_VIEWS['monica-ai']:
        return MONICA_AI_VIEWS.find((item) => item?.id === match.params.id);
      case 'mails':
        return 'mailView';
      default:
        break;
    }
  };

  const refetchTicketViews = () => {
    refetch();
  };

  useEffect(() => {
    EventEmitter.subscribe('manage-workspace-view', () => {
      workspaceSidebarPersonalizationRefetch();
    });

    return () => {
      EventEmitter.unsubscribe('manage-workspace-view');
    };
  }, []);

  useEffect(() => {
    EventEmitter.subscribe('deleteTicketView', refetchTicketViews);
    EventEmitter.subscribe('deleteTaskView', () => {
      refetchTaskViews();
    });

    // after delete the project view, fetching the project view api to show in SideNavigation
    EventEmitter.subscribe('deleteProjectView', () => {
      refetchProjectViews();
    });
    EventEmitter.subscribe('newTaskViewAdded', () => {
      refetchTaskViews();
      workspaceSidebarPersonalizationRefetch();
    });

    // after add the project view, fetching the project view api to show in SideNavigation
    EventEmitter.subscribe('newProjectViewAdded', async (id) => {
      await refetchProjectViews();
      await workspaceSidebarPersonalizationRefetch();
      // if (id) {
      //   // redirect to last added project view - only for create view
      //   await props.history.push(`/project/${id}/project-list`);
      // }
    });

    // To Update the project Views(sidenav) with displayIcons too
    EventEmitter.subscribe('updateProjectView', () => {
      refetchProjectViews();
    });
    return function cleanup() {
      EventEmitter.unsubscribe('deleteTicketView');
      EventEmitter.unsubscribe('deleteTaskView');
      EventEmitter.unsubscribe('deleteProjectView');
      EventEmitter.unsubscribe('newTaskViewAdded');
      EventEmitter.unsubscribe('newProjectViewAdded');
      EventEmitter.unsubscribe('updateProjectView');
    };
  }, []);
  const ROW_COUNT = 50;

  const DEFAULT_LIST_INFO = {
    page: 1,
    pageSize: ROW_COUNT,
    condition: null
  };

  const DEFAULTS_PROJECTS_LISTINFO = {
    ...DEFAULT_LIST_INFO,
    // sort may vary based on the list
    sort: [
      {
        attribute: 'createdTime',
        order: 'DESC'
      }
    ]
  };

  // MOVED TICKET AND TASK CONTEXT VALUES FROM APPHOMEPAGE
  const [viewConditions, setViewConditions] = useStateCallback(null);
  const [projectListInfo, setProjectListInfo] = useGlobalState(
    'projectGlobalFiler',
    DEFAULTS_PROJECTS_LISTINFO
  );

  const reducer = (state, action) => {
    switch (action.type) {
      case 'UPDATE_RECORD':
        return action?.items;
      default:
        return state;
    }
  };

  const [records, dispatch] = useReducer(reducer, []);

  const setRecords = (items) => {
    dispatch({ type: 'UPDATE_RECORD', items });
  };

  const [
    mergeTickets,
    { loading: mergeTicketLoading, error: mergeTicketError }
  ] = useMutation(MERGE_TICKET, {
    onCompleted({ mergeTickets }) {
      toast('success', 'Ticket merged successfully');
      setRecords([]);
    },
    onError({ graphQLErrors }) {}
  });

  const [
    updateTickets,
    { loading: updating, error: updateError }
  ] = useMutation(UPDATE_TICKETS, {
    onCompleted({ markSpamTickets }) {
      toast('success', 'Tickets updated successfully');
      setRecords([]);
    }
  });

  const [
    softDeleteTickets,
    { loading: deletingTicket, error: errorDelete }
  ] = useMutation(SOFT_TICKET_DELETE, {
    onCompleted({ softDeleteTickets }) {
      toast('success', 'Ticket deleted successfully');
      setRecords([]);
    }
  });

  const [
    markSpamTickets,
    { loading: spamming, error: spamError }
  ] = useMutation(MARKSPAM_TICKETS, {
    onCompleted({ markSpamTickets }) {
      toast('success', 'Ticket spammed successfully');
      setRecords([]);
    }
  });

  const [
    restoreTickets,
    { loading: restoring, error: restoreError }
  ] = useMutation(RESTORE_TICKETS, {
    onCompleted({ restoreTickets }) {
      if (restoreTickets) {
        toast('success', 'toast.tickets.list.restore.success');
        setRecords([]);
      }
    }
  });

  const [
    hardDeleteTickets,
    { loading: deleting, error: deleteError }
  ] = useMutation(HARD_TICKET_DELETE, {
    onCompleted({ hardDeleteTickets }) {
      if (hardDeleteTickets) {
        toast('success', 'toast.tickets.list.hardDelete.success');
        setRecords([]);
      }
    }
  });

  const [createTask, { loading: taskLoading, error: taskError }] = useMutation(
    CREATE_TASK,
    {
      onCompleted({ createTask }) {
        toast('success', 'Task created successfully');
      }
    }
  );

  const [
    saveTicketConversation,
    { loading: conversationLoading, error: conversationError }
  ] = useMutation(SAVE_TICKET_CONVERSATION, {
    onCompleted({ saveTicketConversation }) {
      toast('success', 'New node created successfully');
      setRecords([]);
    }
  });

  const setViewConditionsCb = (c, cb) => {
    setViewConditions(c, cb);
  };

  const ticketContextValue = {
    ...context,
    setViewConditions: setViewConditionsCb,
    setProjectListInfo,
    projectListInfo,
    records: records,
    viewConditions: viewConditions,
    setRecords: (items) => {
      setRecords(items);
    },
    softDeleteTickets: softDeleteTickets,
    markSpamTickets: markSpamTickets,
    restoreTickets,
    hardDeleteTickets,
    createTask: createTask,
    mergeTickets: mergeTickets,
    updateTickets: updateTickets,
    saveTicketConversation: saveTicketConversation,
    mergeTicketLoading,
    softDeleteLoading: deletingTicket,
    spamming,
    restoring,
    hardDeleteLoading: deleting
  };

  function getTicketRedirectUrl() {
    const ticketViews = getPersonalizedTicketViews();
    return `/ticket/${ticketViews[0]?.id}/ticket-list`;
  }

  function getProjectRedirectUrl() {
    const projectViews = getPersonalizedProjectViews();
    if (projectViews.length) {
      return `/project/${projectViews[0]?.id}/project-list`;
    } else {
      return `/project/6/project-list`;
    }
  }

  // MOVED TICKET AND TASK CONTEXT VALUES FROM APPHOMEPAGE

  if (
    loading ||
    taskViewLoading ||
    projectViewsLoading ||
    entitiesLoading ||
    workspaceSidebarPersonalizationLoading
  )
    return (
      <SkeletonLoading
        hideSecondaryHeader
        hideHeaderSub
        removeTableMargin
        hideThumbnail
        headerSecondaryActionCount={3}
      />
    );

  let redirectUrl = '';

  const isWorkspaceModules =
    WORKSPACE_MODULE_VIEWS[match.params.viewtype] || null;
  const isListView = match.params?.pagename?.includes('list');

  // if not a workspace module or not a list view, return null
  if (!isWorkspaceModules || !isListView) {
    return null;
  }

  // get the active view
  const activeView = getActiveView(match.params.viewtype);

  if (!activeView) {
    if (match.params.viewtype === 'tasks') {
      const taskViews = getPersonalizedTaskViews();
      if (!taskViews?.length) {
        redirectUrl = getTicketRedirectUrl();
      }
      redirectUrl = `/tasks/${taskViews[0].id}/task-list`;
    } else if (match.params.viewtype === 'project') {
      //to navigate to the project view based on params url having
      redirectUrl = getProjectRedirectUrl();
    } else {
      redirectUrl = getTicketRedirectUrl();
    }
  }
  return !activeView ? (
    <Redirect to={redirectUrl} />
  ) : (
    <>
      <TicketContext.Provider value={ticketContextValue}>
        <MainNavigation
          ticketViews={data?.getTicketViews}
          activeView={activeView}
          taskViews={taskViewData?.getTaskViews}
          viewType={match.params.viewtype}
          projectViews={projectViewsData?.getProjectViews}
          entitiesMeta={allEntities?.getEntitiesMeta}
          context={context}
          flags={flags}
          {...props}
        />
      </TicketContext.Provider>
    </>
  );
}

export default React.memo(withErrorBoundary(withRouter(StepNavigation)));
